import React, { useEffect, useState } from 'react';
import { getToken, onMessage, onBackgroundMessage } from 'firebase/messaging';
import { messaging } from 'lib/firebase';
import { NotificationsConsent } from 'components/Notifications';

const VAPID_KEY =
  'BHg8G7gzUpRJzqkKngahHybH3OdUQmOlxYA3q2DytjrLyFyzAh_WUG1Y38rbRyPR5frUCeaK0vnqsoSH2rNc9y8';

export const FCMTokenManager = ({ onTokenReceived }) => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // On mount, check if permission already granted
    if (Notification.permission === 'granted') {
      getAndStoreFCMToken();
    } else if (Notification.permission === 'default') {
      setShowConsent(true);
    } else {
      console.log('Notifications blocked by user');
    }
  }, []);

  const getAndStoreFCMToken = async () => {
    try {
      const token = await getToken(messaging, {
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: await navigator.serviceWorker.ready,
      });
      if (token) {
        onTokenReceived(token);
      }
    } catch (err) {
      console.error('Error getting token:', err);
    }
  };

  const handleConsentGiven = async () => {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      await getAndStoreFCMToken();
    } else {
      console.log('User denied permission');
    }
    setShowConsent(false);
  };

  return showConsent ? (
    <NotificationsConsent onTokenReceived={handleConsentGiven} />
  ) : null;
};
